import React from "react";
import * as MuiIcons from "@mui/icons-material";

const VARIANT_LABELS = {
    Outlined: "Kontur",
    Rounded: "Rund",
    Sharp: "Scharf",
    TwoTone: "Zweifarbig",
};

const EXACT_LABELS = {
    AccountBalance: "Bank / Institution",
    AccountCircle: "Benutzerkonto",
    Add: "Hinzufügen",
    Apartment: "Gebäude / Apartment",
    ArrowBack: "Pfeil zurück",
    ArrowForward: "Pfeil vorwärts",
    Badge: "Ausweis / Abzeichen",
    Bed: "Bett",
    Business: "Gebäude / Firma",
    CalendarMonth: "Kalender",
    Check: "Haken",
    Close: "Schließen",
    Coffee: "Kaffee",
    Delete: "Löschen",
    DirectionsBike: "Fahrrad",
    DirectionsBoat: "Schiff",
    DirectionsBus: "Bus",
    DirectionsCar: "Auto",
    Edit: "Bearbeiten",
    ElectricBike: "E-Bike",
    Email: "E-Mail",
    EmojiEvents: "Trophäe / Auszeichnung",
    Euro: "Euro",
    Favorite: "Favorit / Herz",
    FitnessCenter: "Fitness",
    Flight: "Flugzeug",
    Forest: "Wald",
    Grade: "Auszeichnung / Stern",
    GolfCourse: "Golf",
    Groups: "Gruppen",
    Hiking: "Wandern",
    HolidayVillage: "Feriendorf",
    Home: "Zuhause",
    Hotel: "Hotel",
    House: "Haus",
    Image: "Bild",
    Kayaking: "Kajak",
    Kitchen: "Küche",
    Landscape: "Landschaft",
    Language: "Sprache / Webseite",
    LocalBar: "Bar / Getränk",
    LocalDining: "Besteck / Essen",
    LocalOffer: "Angebot / Tag",
    LocalParking: "Parkplatz",
    LocationCity: "Stadt",
    LocationOn: "Standort",
    Map: "Karte",
    Menu: "Menü",
    Payments: "Zahlung",
    Phone: "Telefon",
    Pool: "Schwimmen / Pool",
    Restaurant: "Restaurant",
    RestaurantMenu: "Speisekarte",
    Save: "Speichern",
    Search: "Suche",
    SetMeal: "Fisch / Menü",
    Spa: "Wellness / Spa",
    SportsMotorsports: "Motorrad",
    SportsTennis: "Tennis",
    Star: "Stern",
    Store: "Laden",
    Terrain: "Berge / Gelände",
    Train: "Zug",
    Tram: "Straßenbahn",
    Verified: "Verifiziert / Qualität",
    Visibility: "Anzeigen",
    WbSunny: "Sonne",
};

const WORD_LABELS = {
    Account: "Konto",
    Add: "Hinzufügen",
    Alarm: "Alarm",
    Apps: "Apps",
    Arrow: "Pfeil",
    Auto: "Auto",
    Back: "Zurück",
    Balance: "Waage",
    Bar: "Bar",
    Beach: "Strand",
    Bike: "Fahrrad",
    Boat: "Schiff",
    Book: "Buch",
    Bookmark: "Lesezeichen",
    Build: "Werkzeug",
    Business: "Firma",
    Calendar: "Kalender",
    Call: "Anruf",
    Car: "Auto",
    Card: "Karte",
    Check: "Haken",
    City: "Stadt",
    Close: "Schließen",
    Cloud: "Wolke",
    Coffee: "Kaffee",
    Contact: "Kontakt",
    Credit: "Kredit",
    Delete: "Löschen",
    Dining: "Essen",
    Directions: "Richtung",
    Done: "Erledigt",
    Download: "Herunterladen",
    Edit: "Bearbeiten",
    Email: "E-Mail",
    Event: "Termin",
    Events: "Auszeichnung",
    Favorite: "Favorit",
    Fitness: "Fitness",
    Flight: "Flug",
    Food: "Essen",
    Forest: "Wald",
    Forward: "Vorwärts",
    Grade: "Bewertung",
    Group: "Gruppe",
    Groups: "Gruppen",
    Help: "Hilfe",
    Home: "Zuhause",
    Hotel: "Hotel",
    House: "Haus",
    Image: "Bild",
    Info: "Info",
    Kitchen: "Küche",
    Label: "Label",
    Landscape: "Landschaft",
    Language: "Sprache",
    Local: "Lokal",
    Location: "Standort",
    Lock: "Schloss",
    Mail: "E-Mail",
    Map: "Karte",
    Menu: "Menü",
    Money: "Geld",
    More: "Mehr",
    Notifications: "Benachrichtigung",
    Offer: "Angebot",
    Park: "Park",
    Parking: "Parkplatz",
    Payment: "Zahlung",
    Payments: "Zahlungen",
    Person: "Person",
    Phone: "Telefon",
    Photo: "Foto",
    Place: "Ort",
    Pool: "Pool",
    Print: "Drucken",
    Restaurant: "Restaurant",
    Room: "Zimmer",
    Save: "Speichern",
    Search: "Suche",
    Settings: "Einstellungen",
    Shop: "Shop",
    Spa: "Wellness",
    Sports: "Sport",
    Star: "Stern",
    Store: "Laden",
    Sunny: "Sonne",
    Terrain: "Gelände",
    Train: "Zug",
    Upload: "Hochladen",
    Verified: "Verifiziert",
    Visibility: "Sichtbarkeit",
};

export const POPULAR_MATERIAL_ICON_VALUES = [
    "Restaurant",
    "RestaurantMenu",
    "LocalDining",
    "Hotel",
    "Bed",
    "LocationOn",
    "LocationCity",
    "Map",
    "DirectionsCar",
    "LocalParking",
    "Train",
    "Tram",
    "DirectionsBus",
    "Flight",
    "DirectionsBoat",
    "DirectionsBike",
    "ElectricBike",
    "Terrain",
    "Landscape",
    "Forest",
    "Park",
    "Pool",
    "Spa",
    "FitnessCenter",
    "GolfCourse",
    "SportsTennis",
    "Star",
    "Grade",
    "EmojiEvents",
    "Verified",
    "LocalOffer",
    "Phone",
    "Email",
    "Language",
    "Home",
    "House",
    "Apartment",
    "Business",
    "Image",
    "Search",
    "Edit",
    "Delete",
    "Save",
];

function splitIconName(name) {
    return String(name || "")
        .replace(/TwoTone$/, " TwoTone")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
}

function stripVariant(name) {
    const match = String(name || "").match(/(Outlined|Rounded|Sharp|TwoTone)$/);
    if (!match) return { baseName: name, variant: "" };
    return {
        baseName: name.slice(0, -match[1].length),
        variant: match[1],
    };
}

function iconLabel(name) {
    const { baseName, variant } = stripVariant(name);
    const baseLabel = EXACT_LABELS[baseName] || splitIconName(baseName)
        .map((part) => WORD_LABELS[part] || part)
        .join(" ");
    return [baseLabel, VARIANT_LABELS[variant]].filter(Boolean).join(" - ");
}

function isIconExport(name, value) {
    return (
        typeof value === "object" ||
        typeof value === "function"
    ) && /^[A-Z]/.test(name) && name !== "default";
}

export const MATERIAL_ICON_OPTIONS = [
    { value: "", label: "Kein Icon", Icon: null },
    ...Object.entries(MuiIcons)
        .filter(([name, value]) => isIconExport(name, value))
        .map(([name, Icon]) => ({
            value: name,
            label: iconLabel(name),
            searchText: `${name} ${iconLabel(name)}`,
            Icon,
        }))
        .sort((a, b) => a.label.localeCompare(b.label, "de", { sensitivity: "base" })),
];

export const POPULAR_MATERIAL_ICON_OPTIONS = [
    MATERIAL_ICON_OPTIONS[0],
    ...POPULAR_MATERIAL_ICON_VALUES
        .map((value) => MATERIAL_ICON_OPTIONS.find((option) => option.value === value))
        .filter(Boolean),
];

export function getMaterialIconComponent(iconName) {
    const value = String(iconName || "").trim();
    if (!value) return null;
    return MuiIcons[value] || null;
}

export function MaterialIcon({ iconName, sx, ...props }) {
    const Icon = getMaterialIconComponent(iconName);
    if (!Icon) return null;
    return <Icon fontSize="small" sx={sx} {...props} />;
}
